import { useState } from "react";
import { useLanguage } from "@/context/LanguageContext";
import { indexLabels } from "@/i18n";
import AuctionGroups from "@/components/index/AuctionGroups";
import { CarValuationWidget } from "@/components/valuation/CarValuationWidget";
import { useAuth } from "@/hooks/useAuth";
import AuthDialog from "@/components/auth/AuthDialog";
import { useNavigate } from "react-router-dom";
import SellerBenefits from "@/components/howitworks/content/seller/SellerBenefits";
import BuyerBenefits from "@/components/howitworks/content/buyer/BuyerBenefits";
import PaymentSection from "@/components/buycarauctions/DeliverySection/PaymentSection";
import HeroSection from "@/components/index/HeroSection";
import VehicleListingsGrid from "@/components/index/VehicleListingsGrid";
import { Dialog, DialogContent } from "@/components/ui/dialog";
import { usePublicAuctionCampaigns } from "@/hooks/useCampaigns";
import OtherListingsCarousel from "@/components/car-listing/OtherListingsCarousel";
import { ListingOverview } from "@/types/listing";
import { buildAuctionListingPath } from "@/lib/listingUrl";

const Index = () => {
  const [showValuation, setShowValuation] = useState(false);
  const [showAuthDialog, setShowAuthDialog] = useState(false);
  const { isAuthenticated } = useAuth();
  const navigate = useNavigate();
  const { language } = useLanguage();
  const labels = indexLabels(language);

  // Fetch public auction campaigns
  const { publicAuctionCampaigns, isLoadingPublicAuctionCampaigns } =
    usePublicAuctionCampaigns(4);

  const handleListingClick = (listing: ListingOverview) => {
    const from = { from: "/", fromScrollY: window.scrollY };
    if (listing.campaignId) {
      navigate(buildAuctionListingPath(listing.campaignId, listing), {
        state: from,
      });
      return;
    }
    navigate("/auctions", { state: from });
  };

  const handleGroupClick = (campaignId: string) => {
    const campaign = publicAuctionCampaigns.find((c) => c.id === campaignId);

    if (campaign?.status === "upcoming" && isAuthenticated) {
      return;
    }

    navigate(`/auctions/${campaignId}`, {
      state: { from: "/", fromScrollY: window.scrollY },
    });
  };

  return (
    <div className="min-h-screen bg-transparent mx-4 md:mx-2 pt-6">
      {/* Hero Section with Valuation */}
      <HeroSection onValuationClick={() => setShowValuation(true)} />

      <Dialog open={showValuation} onOpenChange={setShowValuation}>
        <DialogContent className="max-w-3xl max-h-[85%] overflow-y-auto">
          <CarValuationWidget
            onClose={() => setShowValuation(false)}
            showCloseButton={false}
          />
        </DialogContent>
      </Dialog>

      <div className="relative space-y-12">
        <OtherListingsCarousel
          title={labels.carousel.selectedListings}
          onCarClick={handleListingClick}
        />

        {/* <h3 className="text-center text-xl md:text-2xl font-bold mb-4 mt-8">
          {labels.campaigns.title}
        </h3> */}
        {isLoadingPublicAuctionCampaigns ? (
          <div className="text-center">{labels.campaigns.loading}</div>
        ) : (
          <AuctionGroups
            groups={publicAuctionCampaigns}
            onGroupClick={handleGroupClick}
            isAuthenticated={isAuthenticated}
          />
        )}

        {/* Vehicle Listings Grid - 5-6 rows */}
        <VehicleListingsGrid onCarClick={handleListingClick} />

        {/* Identity verification + benefits */}
        <div className="space-y-8 pb-8">
          <PaymentSection />
          <div className="flex flex-col md:flex-row gap-4">
            <SellerBenefits />
            <BuyerBenefits />
          </div>
        </div>
      </div>

      <AuthDialog open={showAuthDialog} onOpenChange={setShowAuthDialog} />
    </div>
  );
};

export default Index;
